<app-wizard-bar-nav [frmDisabled]="isReadOnly" [stepIsDirty]="this.isQuoteRequestInvalidated()"></app-wizard-bar-nav>

<div class="step-container main-content">
  <h2 *ngIf="originalQuoteRequestId">Renewing Quote {{ originalQuoteRequestId }}</h2>
  <h2 *ngIf="originalQuoteRequestDueDate">Your new contract start date must be later than {{ originalQuoteRequestDueDate | date }}</h2>

  <h3>
    Utility Accounts |
    <app-company-quoteid-header [quote]="quoteRequestState"></app-company-quoteid-header>
  </h3>

  <app-utility-accounts-grid
    [quoteRequestId]="quoteRequestId"
    (init)="gridInit($event)"
    [quoteRequestState]="quoteRequestState"
    [userIdentity]="userIdentity"
    [showRateCode]="true"
    [nextButtonClicked]="nextButtonClicked.asObservable()"
  ></app-utility-accounts-grid>
</div>

<app-wizard-step-nav-buttons (backClicked)="back()" (nextClicked)="next()"></app-wizard-step-nav-buttons>
